import { PATH_DELIMITER, USER_INFO_PATH } from '../../../constant/Constant';
import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';
import AuthenticationUtil from '../../../util/AuthenticationUtil';

const ACTION_USER_INFO_PASSWORD = USER_INFO_PATH + PATH_DELIMITER + 'ACTION_USER_INFO_PASSWORD';
const ACTION_USER_INFO_BASE_SEARCH = USER_INFO_PATH + PATH_DELIMITER + 'ACTION_USER_INFO_BASE_SEARCH';
const ACTION_USER_INFO_BASE_EDIT = USER_INFO_PATH + PATH_DELIMITER + 'ACTION_USER_INFO_BASE_EDIT';
const ACTION_USER_INFO_WITHDRAWAL = USER_INFO_PATH + PATH_DELIMITER + 'ACTION_USER_INFO_WITHDRAWAL';

const HANDLE_USER_INFO_BASE = USER_INFO_PATH + PATH_DELIMITER + 'HANDLE_USER_INFO_BASE';

export const actionUserInfoPassword = createAction(ACTION_USER_INFO_PASSWORD);
export const actionUserInfoBaseSearch = createAction(ACTION_USER_INFO_BASE_SEARCH);
export const actionUserInfoBaseEdit = createAction(ACTION_USER_INFO_BASE_EDIT);
export const actionUserInfoWithdrawal = createAction(ACTION_USER_INFO_WITHDRAWAL);

export function* userInfoSagas() {
    yield takeEvery(ACTION_USER_INFO_PASSWORD, actionUserInfoPasswordSaga);
    yield takeEvery(ACTION_USER_INFO_BASE_SEARCH, actionUserInfoBaseSearchSaga);
    yield takeEvery(ACTION_USER_INFO_BASE_EDIT, actionUserInfoBaseEditSaga);
    yield takeEvery(ACTION_USER_INFO_WITHDRAWAL, actionUserInfoWithdrawalSaga);
}

function* actionUserInfoPasswordSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/change-password`,
        data,
    });

    if (result > 0) {
        callback && callback();
    }
}

function* actionUserInfoBaseSearchSaga({ payload: data }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/users/${data.userId}`,
    });

    if (result != undefined) {
        yield put({
            type: HANDLE_USER_INFO_BASE,
            payload: { result },
        });
    }
}

function* actionUserInfoBaseEditSaga({ payload }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/users/${payload.userId}/change-info`,
        data: payload,
    });

    if (result > 0) {
        yield actionUserInfoBaseSearchSaga({ payload });
        AuthenticationUtil.setUserNm(payload.userNm);
        payload.callback();
    }
}

function* actionUserInfoWithdrawalSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/users/${data.userId}`,
        params: { ...data },
        callback,
    });
}

const initialState = {
    result: {},
};

const module = handleActions(
    {
        [HANDLE_USER_INFO_BASE]: (state, { payload: result }) => ({ ...state, ...result }),
    },
    initialState,
);

export default module;
